import React from 'react'
import { Grid, Text } from '@vtex/admin-ui'
import { FormattedMessage } from 'react-intl'

import { useOrderFormShippingEstimate } from '../../../../hooks'

export type PickupDeadlineSectionProps = {
  shippingEstimate: string
}

export const PickupDeadlineSection = ({
  shippingEstimate,
}: PickupDeadlineSectionProps) => {
  const { getEstimateMessage } = useOrderFormShippingEstimate()
  // [TODO]<checkout>: Add support for multiple products with differents shipping deadlines

  const estimateMessage = getEstimateMessage(shippingEstimate)

  return (
    <Grid rowGap="1rem">
      <Text variant="title1" tone="secondary">
        <FormattedMessage id="checkout.order-summary.products-for-delivery.deadline-title" />
      </Text>
      <Text variant="title1">{estimateMessage}</Text>
    </Grid>
  )
}
